import type { ControlState } from "../../sim";
import {
	boundCodes,
	controlsFromKeys,
	DEFAULT_BINDINGS,
	type KeyBindings,
	mergeControls,
} from "./bindings";
import { connectedPads, controlsFromPad } from "./gamepad";
import { KeyboardTracker } from "./keyboard";

/** Combines keyboard and gamepad input into one ControlState per local player. */
export class PlayerInput {
	private readonly keyboard: KeyboardTracker;

	constructor(
		private readonly players: number,
		private readonly bindings: readonly KeyBindings[] = DEFAULT_BINDINGS,
	) {
		this.keyboard = new KeyboardTracker(boundCodes(bindings.slice(0, players)));
	}

	read(): ControlState[] {
		const pads = connectedPads();
		return Array.from({ length: this.players }, (_, i) => {
			const keys = this.bindings[i];
			const fromKeys = keys ? controlsFromKeys(this.keyboard.held, keys) : undefined;
			const fromPad = controlsFromPad(pads[i]);
			return fromKeys ? mergeControls(fromKeys, fromPad) : fromPad;
		});
	}

	/** Forget held keys (e.g. when pausing) so nothing is stuck on resume. */
	reset(): void {
		this.keyboard.clear();
	}

	destroy(): void {
		this.keyboard.destroy();
	}
}
